module.exports = __webpack_public_path__ + "app-static/img/ycd.8e708728.png";